import { object, string } from 'yup';
import { PERSON_NAME } from '../../helpers/constants';

const FamilyUpdateSchema = object().shape({
  email: string().email('Enter a valid email').required('Email is required'),
  first_name: string().required('Please enter your First Name').matches(PERSON_NAME, 'Please enter a valid first name'),
  last_name: string().required('Please enter your Last Name').matches(PERSON_NAME, 'Please enter a valid last name'),
  mobile_number: string().required('Please enter your phone number'),
});

export default FamilyUpdateSchema;
